import "./ContactUsStyles.css";

function ContactUs() {
  return (
    <div className="contact-container">
      <h1>Send a message to us!</h1>
      <form action="/">
        <input placeholder="Name" type="text" />
        <input placeholder="Email" type="email" />
        <input placeholder="Subject" type="text" />
        <textarea placeholder="message" rows="4"></textarea>
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
}

export default ContactUs;
